export default __webpack_public_path__ + "static/media/soal-2-left.1cfcfc64.png";